import { render, staticRenderFns } from "./JobChat.vue?vue&type=template&id=4886a346&scoped=true&"
import script from "./JobChat.vue?vue&type=script&lang=js&"
export * from "./JobChat.vue?vue&type=script&lang=js&"
import style0 from "./JobChat.vue?vue&type=style&index=0&id=4886a346&prod&lang=css&"
import style1 from "./JobChat.vue?vue&type=style&index=1&id=4886a346&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886a346",
  null
  
)

export default component.exports